// extracted by mini-css-extract-plugin
export var readonly = "_at-1";
export var star = "_at-0";